import {BaseContainerClusterSelect, BaseContainerClusterSelectProps} from "./BaseContainerClusterSelect";
import {useMemo} from "react";
import {
  ContainerClusterSelectorProps,
  containerClustersSelector,
  useGetAllContainerClustersQuery
} from "@ots-frontend/ots-data";

export type ContainerClusterSelectProps = Omit<BaseContainerClusterSelectProps, "entities" | "loading"> & {
  selector?: ContainerClusterSelectorProps
}

export const ContainerClusterSelect = (props: ContainerClusterSelectProps) => {
  const {selector, ...rest} = props;

  const selectContainerClusters = useMemo(() => {
    return containerClustersSelector();
  }, []);

  const {containers, isLoading} = useGetAllContainerClustersQuery(selector?.regionId, {
    selectFromResult: (result) => ({
      containers: selectContainerClusters(result, selector),
      isLoading: result.isLoading
    })
  });

  return <BaseContainerClusterSelect entities={containers} loading={isLoading} {...rest} />;
};
